import React from "react";
import { Fish, ImagePlus, MapPinned } from "lucide-react";

import FeatureConsentModal from "../FeatureConsentModal";
import CreatePostSection from "./CreatePostSection";
import CatchFormDetailsSection, {
  CatchFormDetailsAside,
  CatchFormFeedbackAndActions,
} from "./catch-form/CatchFormDetailsSection";
import CatchFormMediaLocationSection, {
  CatchFormLocationSection,
} from "./catch-form/CatchFormMediaLocationSection";
import useCatchFormState from "./catch-form/useCatchFormState";

function CatchForm(props) {
  const catchForm = useCatchFormState(props);

  return (
    <>
      <fieldset
        className="create-post-form-shell"
        disabled={catchForm.isSubmitting}
      >
        <CreatePostSection
          title={catchForm.t("create_post_section_caption_media")}
          className="create-post-section-card--top create-post-section-card--media"
          icon={ImagePlus}
        >
          <CatchFormMediaLocationSection catchForm={catchForm} />
        </CreatePostSection>

        <div
          className={`catch-form-grid${catchForm.isSimpleModeActive ? " catch-form-grid--simple" : ""}`}
        >
          <div className="catch-form-left">
            <CreatePostSection
              title={catchForm.t("create_post_section_location")}
              className="create-post-section-card--top create-post-section-card--location"
              icon={MapPinned}
            >
              <CatchFormLocationSection catchForm={catchForm} />
            </CreatePostSection>
            <CatchFormDetailsSection catchForm={catchForm} icon={Fish} />
          </div>

          <CatchFormDetailsAside catchForm={catchForm} />
        </div>

        <CatchFormFeedbackAndActions catchForm={catchForm} />
      </fieldset>

      <FeatureConsentModal
        consentKey="acceptExifProcessing"
        title={catchForm.t("catch_exif_consent_title")}
        isOpen={catchForm.showExifConsent}
        isSubmitting={catchForm.isSavingExifConsent}
        error={catchForm.exifConsentError}
        onAccept={catchForm.handleAcceptExifConsent}
        onCancel={catchForm.handleCancelExifConsent}
      />
      <FeatureConsentModal
        consentKey="acceptLocationSharing"
        title={catchForm.t("catch_location_consent_title")}
        isOpen={catchForm.showLocationConsent}
        isSubmitting={catchForm.isSavingLocationConsent}
        error={catchForm.locationConsentError}
        onAccept={catchForm.handleAcceptLocationConsent}
        onCancel={catchForm.handleCancelLocationConsent}
      />
    </>
  );
}

export default CatchForm;
